// @ts-check
import { AddToTranscriptStatus } from '../add-to-transcript-status';
import { Ok } from '@crvouga/result';

/**
 * @typedef {{
 *  type: 'fake'
 * }} Config
 */

/**
 * @type {(config: Config) => import('./interface').AddToTranscriptAPI}
 */
export const AddToTranscriptAPI = () => {
  return {
    async post() {
      return Ok(null);
    },
    async get() {
      return Ok({ status: AddToTranscriptStatus.random() });
    }
  };
};
